"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRIGGER = void 0;
exports.TRIGGER = {
    HOVER: 'hover',
    CLICK: 'click',
    FOCUS: 'focus',
};
